export enum EComponentTypes {
    basic,
    modul,
    custom
}
